import _ from 'lodash';
import { adapi } from '~';

const SET_CURRENT = 'SET_CURRENT';
const SET_LOADING = 'SET_LOADING';

const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
const SET_NOTIFICATIONS_LIMIT = 'SET_NOTIFICATIONS_LIMIT';
const SET_NOTIFICATIONS_LOADING = 'SET_NOTIFICATIONS_LOADING';

const SET_CAMPAIGNS = 'SET_CAMPAIGNS';
const SET_CAMPAIGNS_OFFSET = 'SET_CAMPAIGNS_OFFSET';
const SET_CAMPAIGNS_LOADING = 'SET_CAMPAIGNS_LOADING';

const NOTIFICATIONS_OFFSET = 10;

const getters = {
  currentCustomer(state) {
    return state.current;
  },
};

const actions = {
  getCustomer({ commit }, id) {
    commit(SET_LOADING, true);

    // Force notification clear to not display wrong entries if customer changes
    commit(SET_NOTIFICATIONS, { notifications: [] });
    commit(SET_CAMPAIGNS, { campaigns: [] });

    return adapi.get(`customers/${id}`)
      .then(result => {
        commit(SET_NOTIFICATIONS_LIMIT, 0);
        commit(SET_CAMPAIGNS_OFFSET, 0);
        commit(SET_CURRENT, { current: result, error: null });
        commit(SET_CAMPAIGNS, { campaigns: result.campaigns || [] });
        commit(SET_LOADING, false);
      })
      .catch(error => {
        commit(SET_CURRENT, { current: null, error });
        commit(SET_LOADING, false);
        throw error;
      });
  },
  getMoreNotifications({ commit, state }) {
    commit(SET_NOTIFICATIONS_LOADING, true);
    commit(SET_NOTIFICATIONS_LIMIT, state.notificationsLimit + NOTIFICATIONS_OFFSET);

    return adapi.get(`customers/${state.current.id}/notifications`, {
      limit: state.notificationsLimit,
      skipcache: 1, // we need newest notifications every time
    })
      .then(result => {
        commit(SET_NOTIFICATIONS, { notifications: result, error: null });
        commit(SET_NOTIFICATIONS_LOADING, false);
      })
      .catch(error => {
        commit(SET_NOTIFICATIONS, { notifications: [], error });
        commit(SET_NOTIFICATIONS_LOADING, false);
      });
  },
  getMoreCampaigns({ commit, state }) {
    commit(SET_CAMPAIGNS_LOADING, true);
    const newOffset = state.campaignsOffset + NOTIFICATIONS_OFFSET;
    if (state.campaigns.length === newOffset) {
      commit(SET_CAMPAIGNS_OFFSET, newOffset);
    }

    return adapi.get(`customers/${state.current.id}`, {
      campaign_offset: state.campaignsOffset,
      campaign_limit: NOTIFICATIONS_OFFSET,
      skipcache: 1, // we need newest campaigns every time
    })
      .then(result => {
        const campaigns = state.campaigns.concat(result.campaigns || []);
        commit(SET_CAMPAIGNS, { campaigns: _.uniqBy(campaigns, 'code') });
        commit(SET_CAMPAIGNS_LOADING, false);
      })
      .catch(() => {
        commit(SET_CAMPAIGNS_LOADING, false);
      });
  },
};

const mutations = {
  [SET_CURRENT](state, { current, error }) {
    state.current = current;
    state.error = error;
  },
  [SET_LOADING](state, loading) {
    state.loading = loading;
  },
  [SET_NOTIFICATIONS](state, { notifications, error }) {
    state.notifications = notifications;
    state.notificationsError = error;
  },
  [SET_NOTIFICATIONS_LOADING](state, loading) {
    state.notificationsLoading = loading;
  },
  [SET_NOTIFICATIONS_LIMIT](state, limit) {
    state.notificationsLimit = limit;
  },
  [SET_CAMPAIGNS](state, { campaigns }) {
    state.campaigns = campaigns;
  },
  [SET_CAMPAIGNS_LOADING](state, loading) {
    state.campaignsLoading = loading;
  },
  [SET_CAMPAIGNS_OFFSET](state, limit) {
    state.campaignsOffset = limit;
  },
};

export default {
  namespaced: true,
  state: {
    notificationsLimit: 0,
    notifications: [],
    notificationsLoading: false,
    notificationsError: null,
    campaignsOffset: 0,
    campaignsLoading: false,
    campaigns: [],
    current: null,
    error: null,
    loading: true,
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/customer.js